const BASE_URL = {
    BASE_URL: 'https://unit20.smartekanban.in',
    API_URL: '/index.php/Apiv6'
};  

const SUB_URL = {
    get_kanban_data: '/get_kanban_details',
    login: '/eol_user_login',
    add_eol_dispatch: '/add_eol_dispatch',
    get_dashboard_data: '/get_dashboard_data',
    getLine: '/get_lines',
    get_item_no: '/get_item_no',
    get_po_by_item: '/get_purchase_orders',
    get_color: '/get_colors',
    get_eol_report: '/eol_dispatch_report',
    display_active_kanban: '/display_active_kanban',
    add_bin: '/add_bin',
    get_bins: '/get_bins',
    view_bin: '/view_bin',
    deleteKanbanByDbdid: '/delete_kanban_bydbdid',
    editKanban: '/edit_kanban_bydbdid',
    add_garment: '/add_garment_details', 
    add_garments: '/add_garments',

    getMaster_get_bins_details: '/get_bins_details',
    get_inward_outward_report: '/inward_outward_report',

    Kanban_Count_accuracy: '/Kanban_Count_accuracy',
    scan_barcode: "/scan_barcode",

};

const SUB_URL_wash = {
    view_bin: '/view_bin',
    outward: '/washing_bin_outward',
    in_ward: '/washing_bin_inward',
    washing: '/send_bin_to_washing',
};

const SUB_URL_GSM = {
    GSM_inward: '/garment_supermarket_inward',
    getGSMBin: '/get_gsm_bins',
    GSM_outward: '/garment_supermarket_outward',
};

const SUB_URL_dispatch_center = {
    bin_bulk_outward: '/send_bulk_bin_to_washing',
    getBinByBinId: '/get_dispatch_bin',
    getBulkBindata: '/get_bulk_bins_details',
};

const SUB_URL_KCA = {
    get_kca_daily_report: '/get_kca_daily_report',
};

const SUB_URL_Checker = {
    prepare_eol_screen: '/prepare_eol_screen',
    get_userline_and_items: '/get_userline_and_items',
    get_inline_parts: '/get_inline_parts',
    get_inline_defect_reason: '/get_inline_defect_reason',
    get_inline_operations: '/get_inline_operations',
};

export {
    BASE_URL,
    SUB_URL,
    SUB_URL_wash,
    SUB_URL_GSM,
    SUB_URL_dispatch_center,
    SUB_URL_KCA,
    SUB_URL_Checker
};
